import { WINDOW } from '../config/constants';

export const ifDesktop = (width: number) => {
  return width > 768 ? WINDOW.MAX_WIDTH_DESKTOP : WINDOW.MAX_WIDTH;
};

export const isDesktop = (width: number) => {
  return width > 768;
};
